import { render, staticRenderFns } from "./RoomManage.vue?vue&type=template&id=4c50a8ba&scoped=true"
import script from "./RoomManage.vue?vue&type=script&lang=js"
export * from "./RoomManage.vue?vue&type=script&lang=js"
import style0 from "./RoomManage.vue?vue&type=style&index=0&id=4c50a8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50a8ba",
  null
  
)

export default component.exports